<template>

  <button
    type="button"
    class="dropdown-item"
    @click="deleteCandidate">
    <i class="fas fa-times" /> {{ $t('Delete') }}
    </button>

</template>

<script>
export default {
  name: 'JobActionMassDelete',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    candidates () {
      return this.$store.getters.getCandidateSelected
    }
  },
  created () {
  },
  methods: {
    /*
    deleteCandidate
    */
    deleteCandidate () {
      const deleteAction = () => {
        this.candidates.forEach(candidate => {
          this.$store.dispatch('deleteCandidate', candidate._id)
        })
        this.$store.dispatch('resetCandidateSelected')
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction,
        message: 'Ao excluir este candidato, você removerá todos os dados relacionados. Você não verá mais nenhum relatório para este candidato.<br><br><ul class="list-group"><li class="list-group-item list-group-item-danger"><i class="fas fa-times"></i> Todos os detalhes de contato serão excluídos</li><li class="list-group-item list-group-item-danger"><i class="fas fa-times"></i> Todas as mensagens de e-mail serão excluídas</li><li class="list-group-item list-group-item-danger"><i class="fas fa-times"></i> Todas as avaliações serão excluídas</li><li class="list-group-item list-group-item-danger"><i class="fas fa-times"></i> Todos os arquivos serão excluídos</li></ul>'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobMassiveAction/JobMassiveActionDelete.vue